<template>
  <div class="filters-container">
    <el-row :gutter="24">
      <custom-input
        v-model="filters.Descripcion"
        :label="'Descripción'"
        :spanColumn="5"
        :settings="{
          placeholder: 'Descripción',
        }"
      />
      <custom-switch
        v-model="filters.Activo"
        :spanColumn="2"
        :label="'Activo'"
      />
      <el-col
        :span="3"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrarTipoTratado"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="LimpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomSwitch from '@/shared/components/custom_switch.vue';
import { useTipoTratadoStore } from '../stores/tipo_tratado_store.js';
import IconDelete from '~icons/mdi/delete';

const tipoTratadoStore = useTipoTratadoStore();
const { filters } = storeToRefs(tipoTratadoStore);

const LimpiarFiltros = () => {
  tipoTratadoStore.setPage(1);
  tipoTratadoStore.emptyList();
  tipoTratadoStore.resetFilters();
  tipoTratadoStore.findAllTipoTratadosHTTP();
};

const filtrarTipoTratado = () => {
  tipoTratadoStore.setPage(1);
  tipoTratadoStore.emptyList();
  tipoTratadoStore.findAllTipoTratadosHTTP();
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.button-container {
  /* Estilo específico para el contenedor del botón */
  margin-top: auto; /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}
.margin-row {
  margin-top: 1%;
}
</style>
